document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.deep-subtitle');

  if (elements.length) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    elements.forEach(el => observer.observe(el));
  }
});
